import './related_product_item_component.scss'
